import { useState } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@tellescope/ui";
import { Spinner } from "@tellescope/design-system";

export interface VerificationEmbedProps {
  src: string;
  title: string;
}

export const VerificationEmbed = ({ src, title }: VerificationEmbedProps) => {
  const { t } = useTranslation("onboarding");
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className="relative min-h-0 flex-1">
      {!isLoaded && (
        <div className="absolute inset-0 z-10 flex flex-col gap-4 items-center justify-center rounded-md border bg-background">
          <Spinner />
          <p className="text-sm text-muted-foreground">{t("Loading verification...")}</p>
        </div>
      )}
      <iframe
        title={title}
        className={cn("h-full w-full rounded-md border", !isLoaded && "invisible")}
        src={src}
        onLoad={() => setIsLoaded(true)}
      />
    </div>
  );
};
